import { useContext } from "react";
import { SelectedSupplierContext } from "../context/SelectedSupplierContext";

const useSelectedSupplier = () => {
    const context = useContext(SelectedSupplierContext);
    if (!context) throw new Error("useSelectedSupplier must be used within SelectedSupplierProvider");
    return context;
};

export default useSelectedSupplier;
